import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  ModuleRegistry,
  AllCommunityModule,
  provideGlobalGridOptions,
} from 'ag-grid-community';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// AG Grid 33+ requires explicit module registration. Register the
// full community bundle once at bootstrap; every <ag-grid-angular>
// instance across the app shares this registration.
ModuleRegistry.registerModules([AllCommunityModule]);

// AG Grid 33+ ships a new Theming API by default. Our grids use the
// legacy CSS-class theming (<div class="ag-theme-alpine">...) via the
// imported ag-theme-alpine.css in styles.scss. Opt into legacy mode
// globally so the existing CSS classes still drive the look.
provideGlobalGridOptions({ theme: 'legacy' });

// Defense in depth: even if set-env.ts is accidentally weakened, refuse
// to boot a prod build that also has the E2E bypass compiled in.
if (environment.production && environment.E2E_BYPASS_ENABLED) {
  throw new Error(
    'Refusing to start: production build has E2E_BYPASS_ENABLED=true. ' +
      'Check set-env.ts and CI env vars.',
  );
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
   
  console.error(err),
);
